import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import {
  PAGE_CONST,
  PERMISSION_TYPE,
  PERMISSION_FEATURE,
  PAYMENT_MODE_OPTIONS,
} from '../../common/constant/page-constant'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { redirect } from '../../common/utils/redirectionUtils'
import MobileHeader from '../Common/Header/MobileHeader'

import Select from 'react-select'
import CloseIcon from '../../assets/CloseIcon'
import DownloadIcon from '../../assets/DownloadIcon'
import { convertToTitleCase } from '../../common/utils/appUtils'
import {
  downloadReportExcelHelper,
  downloadReportPdfHelper,
  getReportHelper,
  getInvoiceDetailsHelper,
  getSalesOrderHelper,
} from '../../helper/home-helper'
import { getBranchHelper } from '../../helper/branch-management-helper'
import currencyFormatter from './../../common/utils/currencyFormatterUtils'
import Loading from './../../components/Loding/Loading'
import ViewInventory from '../ManageInventory/ViewInventory'
import ViewSales from '../Sales/ViewSales'
import './Reports.scss'

const Reports = (props) => {
  const navigate = useNavigate()
  const isMobile = useCheckMobileScreen()
  const [selectedSupplierProductType, setSelectedSupplierProductType] = useState(undefined)
  const [isViewInventoryActive, setViewInventoryActive] = useState(false)
  const [invoiceData, setInvoiceData] = useState(null)

  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.REPORTS,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => redirect(navigate, PAGE_CONST.HOME),
  })

  const [startDate, setStartDate] = useState(undefined)
  const [endDate, setEndDate] = useState(undefined)
  const [reportType, setReportType] = useState(undefined)
  const [subType, setSubType] = useState(undefined)
  const [selectedSupplier, setSelectedSupplier] = useState(undefined)
  const [selectedProductType, setSelectedProductType] = useState(undefined)
  const [selectedGenericName, setSelectedGenericName] = useState(undefined)
  const [reportOrderData, setReportOrderData] = useState(undefined)
  const [filterReportOrderData, setFilterReportOrderData] = useState(undefined)
  const [reportInvoicePurchaseData, setReportInvoicePurchaseData] =
    useState(undefined)
  const [filterReportInvoicePurchaseData, setFilterReportInvoicePurchaseData] =
    useState(undefined)
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(undefined)

  const [reportSupplierProductData, setReportSupplierProductData] =
    useState(undefined)
  const [
    filteredReportSupplierProductData,
    setFilteredReportSupplierProductData,
  ] = useState(undefined)
  const [dailySalesSummaryData, setDailySalesSummaryData] = useState(undefined)
  const [filteredDailySalesSummaryData, setFilteredDailySalesSummaryData] =
    useState(undefined)
  const [supplierWiseSalesData, setSupplierWiseSalesData] = useState(undefined)
  const [filteredSupplierWiseSalesData, setFilteredSupplierWiseSalesData] =
    useState(undefined)
  const [supplierWiseStockPositionData, setSupplierWiseStockPositionData] =
    useState(undefined)
  const [
    filteredSupplierWiseStockPositionData,
    setFilteredSupplierWiseStockPositionData,
  ] = useState(undefined)
  const [supplierWiseProductMovementData, setSupplierWiseProductMovementData] =
    useState(undefined)
  const [
    filteredSupplierWiseProductMovementData,
    setFilteredSupplierWiseProductMovementData,
  ] = useState(undefined)
  const [selectedOrigin, setSelectedOrigin] = useState(undefined)
  const [selectedGenericNameStock, setSelectedGenericNameStock] = useState(undefined)
  const [selectedGenericNameProductMovement, setSelectedGenericNameProductMovement] = useState(undefined)
  const [expandedProductMovementGroups, setExpandedProductMovementGroups] = useState({})
  const [productExpiryData, setProductExpiryData] = useState(undefined)
  const [filteredProductExpiryData, setFilteredProductExpiryData] = useState(undefined)
  const [selectedVendor, setSelectedVendor] = useState(undefined)
  const [selectedOriginExpiry, setSelectedOriginExpiry] = useState(undefined)
  const [toggle, setToggle] = useState(false)
  const [downloadingType, setDownloadingType] = useState(null) // 'PDF', 'CSV', or null
  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const [branchList, setBranchList] = useState([])
  const [selectedBranch, setSelectedBranch] = useState(undefined)
  const [hasManagePermission, setHasManagePermission] = useState(false)
  const [expandedBranch, setExpandedBranch] = useState(null)
  const [isViewSalesActive, setViewSalesActive] = useState(false)
  const [salesData, setSalesData] = useState(null)

  const handleViewInvoice = (salesOrderId) => {
    getSalesOrderHelper(salesOrderId)
      .then((res) => {
        setSalesData(res)
        setViewSalesActive(true)
      })
      .catch((err) => {
        console.log('Error fetching sales order:', err)
      })
  }

  // Group data by branch name
  const groupDataByBranch = (data) => {
    if (!data) return {}
    const grouped = {}
    data.forEach((item) => {
      const branchName = item.branch_name || 'Unknown Branch'
      if (!grouped[branchName]) {
        grouped[branchName] = []
      }
      grouped[branchName].push(item)
    })
    return grouped
  }

  // Calculate totals for Daily Sales Summary branch data
  const calculateDailySalesBranchTotals = (branchData) => {
    return {
      mrp: branchData.reduce((sum, item) => sum + (item.mrp || 0), 0),
      discount: branchData.reduce((sum, item) => sum + (item.discount || 0), 0),
      vat: branchData.reduce((sum, item) => sum + (item.vat || 0), 0),
      ex_ret_amount: branchData.reduce((sum, item) => sum + (item.ex_ret_amount || 0), 0),
      net_amount: branchData.reduce((sum, item) => sum + (item.net_amount || 0), 0),
      cash_sale: branchData.reduce((sum, item) => sum + (item.cash_sale || 0), 0),
      card_sale: branchData.reduce((sum, item) => sum + (item.card_sale || 0), 0),
      online_sale: branchData.reduce((sum, item) => sum + (item.online_sale || 0), 0),
      due_sales: branchData.reduce((sum, item) => sum + (item.due_sales || 0), 0),
      total_cpu: branchData.reduce((sum, item) => sum + (item.total_cpu || 0), 0),
      profit_amount: branchData.reduce((sum, item) => sum + (item.profit_amount || 0), 0),
    }
  }

  // Calculate totals for Supplier and Product report
  const calculateSupplierProductBranchTotals = (branchData) => {
    return {
      rec_qty: branchData.reduce((sum, item) => sum + (item.rec_qty || 0), 0),
      bonus_qty: branchData.reduce((sum, item) => sum + (item.bonus_qty || 0), 0),
      total_qty: branchData.reduce((sum, item) => sum + (item.total_qty || 0), 0),
      total_cost: branchData.reduce((sum, item) => sum + (item.total_cost || 0), 0),
    }
  }

  // Calculate totals for Order Submit report
  const calculateOrderSubmitBranchTotals = (branchData) => {
    return {
      order_qty: branchData.reduce((sum, item) => sum + (item.order_qty || 0), 0),
      total_cost: branchData.reduce((sum, item) => sum + (item.total_cost || 0), 0),
    }
  }

  // Calculate totals for Invoice Wise Purchase report
  const calculateInvoicePurchaseBranchTotals = (branchData) => {
    return {
      amount: branchData.reduce((sum, item) => sum + (item.amount || 0), 0),
      vat: branchData.reduce((sum, item) => sum + (item.vat || 0), 0),
      trade_discount: branchData.reduce((sum, item) => sum + (item.trade_discount || 0), 0),
      total_amount: branchData.reduce((sum, item) => sum + (item.total_amount || 0), 0),
    }
  }

  // Calculate totals for Supplier Wise Sales report
  const calculateSupplierWiseSalesBranchTotals = (branchData) => {
    return {
      sold_qty: branchData.reduce((sum, item) => sum + (item.sold_qty || 0), 0),
      cpu: branchData.reduce((sum, item) => sum + (item.cpu || 0), 0),
      mrp: branchData.reduce((sum, item) => sum + (item.mrp || 0), 0),
      discount: branchData.reduce((sum, item) => sum + (item.discount || 0), 0),
      vat: branchData.reduce((sum, item) => sum + (item.vat || 0), 0),
      sub_total: branchData.reduce((sum, item) => sum + (item.sub_total || 0), 0),
      ex_ret: branchData.reduce((sum, item) => sum + (item.ex_ret || 0), 0),
      net_amount: branchData.reduce((sum, item) => sum + (item.net_amount || 0), 0),
      total_profit: branchData.reduce((sum, item) => sum + (item.total_profit || 0), 0),
    }
  }

  // Calculate totals for Supplier Wise Stock Position report
  const calculateStockPositionBranchTotals = (branchData) => {
    return {
      total_purchased_qty: branchData.reduce((sum, item) => sum + (item.total_purchased_qty || 0), 0),
      total_sold_qty: branchData.reduce((sum, item) => sum + (item.total_sold_qty || 0), 0),
      damage_loss_qty: branchData.reduce((sum, item) => sum + (item.damage_loss_qty || 0), 0),
      exch_return_qty: branchData.reduce((sum, item) => sum + (item.exch_return_qty || 0), 0),
      balance_qty: branchData.reduce((sum, item) => sum + (item.balance_qty || 0), 0),
      total_cost: branchData.reduce((sum, item) => sum + (item.total_cost || 0), 0),
      total_sell_value: branchData.reduce((sum, item) => sum + (item.total_sell_value || 0), 0),
    }
  }

  // Calculate totals for Supplier Wise Product Movement report
  const calculateProductMovementBranchTotals = (branchData) => {
    return {
      total_received_qty: branchData.reduce((sum, item) => sum + (item.total_received_qty || 0), 0),
      total_sold_qty: branchData.reduce((sum, item) => sum + (item.total_sold_qty || 0), 0),
      balance_qty: branchData.reduce((sum, item) => sum + (item.balance_qty || 0), 0),
      total_cost: branchData.reduce((sum, item) => sum + (item.total_cost || 0), 0),
      total_sell_value: branchData.reduce((sum, item) => sum + (item.total_sell_value || 0), 0),
    }
  }

  // Handle View All click - accordion behavior
  const handleViewAllClick = (branchName) => {
    setExpandedBranch(expandedBranch === branchName ? null : branchName)
  }

  // Check if viewing all branches
  const isAllBranchesSelected = selectedBranch?.id === 'ALL'

  // Check if user has manage permission for reports
  useEffect(() => {
    if (props.loginData?.permissions) {
      const hasManage = props.loginData.permissions.some((permissionGroup) => {
        if (permissionGroup.features) {
          // Check if user has MANAGE permission for REPORTS_VIEW (View under Reports)
          return (
            permissionGroup.features[PERMISSION_FEATURE.REPORTS_VIEW] ===
            PERMISSION_TYPE.MANAGE
          )
        }
        return false
      })
      setHasManagePermission(hasManage)

      // Fetch branches if user has manage permission
      if (hasManage) {
        getBranchHelper()
          .then((res) => {
            const branches = res.map((branch) => ({
              id: branch.id,
              name: branch.name,
              label: branch.name,
            }))
            // Add "All Branches" option at the beginning
            setBranchList([
              { id: 'ALL', name: 'ALL', label: 'All Branches' },
              ...branches,
            ])
          })
          .catch((err) => {
            console.log('Error fetching branches:', err)
          })
      }
    }
  }, [props.loginData])
  const setDataEmpty = () => {
    /** Purchase */
    setReportOrderData(undefined)
    setFilterReportOrderData(undefined)
    setReportInvoicePurchaseData(undefined)
    setFilterReportInvoicePurchaseData(undefined)
    setReportSupplierProductData(undefined)
    setFilteredReportSupplierProductData(undefined)

    /** Sales */
    setDailySalesSummaryData(undefined)
    setFilteredDailySalesSummaryData(undefined)
    setSupplierWiseSalesData(undefined)
    setFilteredSupplierWiseSalesData(undefined)

    /** Inventory */
    setSupplierWiseStockPositionData(undefined)
    setFilteredSupplierWiseStockPositionData(undefined)
    setSupplierWiseProductMovementData(undefined)
    setFilteredSupplierWiseProductMovementData(undefined)
    setProductExpiryData(undefined)
    setFilteredProductExpiryData(undefined)

    setSelectedGenericName(undefined)
    setSelectedProductType(undefined)
    setSelectedSupplier(undefined)
    setExpandedBranch(null)
    setSelectedSupplierProductType(undefined)
    setSelectedPaymentMode(undefined)
    setSelectedOrigin(undefined)
    setSelectedGenericNameStock(undefined)
    setSelectedGenericNameProductMovement(undefined)
    setSelectedVendor(undefined)
    setSelectedOriginExpiry(undefined)
  }

  const handleSubmit = async () => {
    if (!startDate || !endDate || !reportType || !subType) return

    let data = {
      startDate: startDate,
      endDate: endDate,
      reportType: reportType?.name,
      subType: subType?.name,
    }

    // Add branch filter if user has manage permission and selected a branch
    if (hasManagePermission && selectedBranch) {
      if (selectedBranch.id === 'ALL') {
        data.allBranches = true
      } else {
        data.branchId = selectedBranch.id
      }
    }

    if (reportType?.name === 'INVENTORY' && subType?.name === 'SUPPLIER_WISE_STOCK_POSITION') {
      data.includeExpired = true
    }

    try {
      console.log('data for report helper: ', data)
      setIsSubmitLoading(true)
      setDataEmpty()

      let res = await getReportHelper(data)

      if (
        reportType?.name === 'PURCHASE' &&
        subType?.name === 'SUPPLIER_AND_PRODUCT'
      ) {
        setReportSupplierProductData(res)
        setFilteredReportSupplierProductData(res?.data || [])
      } else if (
        reportType?.name === 'PURCHASE' &&
        subType?.name === 'ORDER_SUBMIT'
      ) {
        setReportOrderData(res)
        setFilterReportOrderData(res?.data)
      } else if (
        reportType?.name === 'PURCHASE' &&
        subType?.name === 'INVOICE_WISE_PURCHASE_REPORT'
      ) {
        setReportInvoicePurchaseData(res)
        setFilterReportInvoicePurchaseData(res?.data)
      } else if (
        reportType?.name === 'SALES' &&
        subType?.name === 'DAILY_SALES_SUMMARY'
      ) {
        setDailySalesSummaryData(res)
        setFilteredDailySalesSummaryData(res?.data)
      } else if (
        reportType?.name === 'SALES' &&
        subType?.name === 'SUPPLIER_WISE'
      ) {
        setSupplierWiseSalesData(res)
        setFilteredSupplierWiseSalesData(res?.data)
      } else if (
        reportType?.name === 'INVENTORY' &&
        subType?.name === 'SUPPLIER_WISE_STOCK_POSITION'
      ) {
        setSupplierWiseStockPositionData(res)
        const filteredData = res?.data?.filter(item => item.balance_qty !== 0) || []
        setFilteredSupplierWiseStockPositionData(filteredData)
      } else if (
        reportType?.name === 'INVENTORY' &&
        subType?.name === 'SUPPLIER_WISE_PRODUCT_MOVEMENT'
      ) {
        setSupplierWiseProductMovementData(res)
        setFilteredSupplierWiseProductMovementData(groupWithSummarySupplierWiseProductMovement(res?.data))
        setExpandedProductMovementGroups({})
      } else if (
        reportType?.name === 'INVENTORY' &&
        subType?.name === 'PRODUCT_EXPIRY'
      ) {
        setProductExpiryData(res)
        setFilteredProductExpiryData(res?.data)
      }

      console.log('reports response:: ', res)
    } catch (err) {
      console.log('err in get report: ', err)
    } finally {
      setIsSubmitLoading(false)
    }
    // api call
  }

  const filterSupplierReportData = (option) => {
    setSelectedSupplier(option)
    if (!option?.name) {
      setFilteredReportSupplierProductData(reportSupplierProductData?.data)
      setFilterReportOrderData(reportOrderData?.data)
      setFilteredSupplierWiseSalesData(supplierWiseSalesData?.data)
      // Filter out products with 0 balance quantity for stock position
      setFilteredSupplierWiseStockPositionData(
        supplierWiseStockPositionData?.data?.filter(item => item.balance_qty !== 0) || []
      )
      setFilteredSupplierWiseProductMovementData(
        groupWithSummarySupplierWiseProductMovement(supplierWiseProductMovementData?.data)
      )
      setExpandedProductMovementGroups({})
      setFilteredProductExpiryData(productExpiryData?.data)
      return
    }

    setSelectedProductType(undefined)
    setSelectedGenericName(undefined)
    setSelectedSupplierProductType(undefined)
    setSelectedOrigin(undefined)
    setSelectedGenericNameStock(undefined)
    setSelectedGenericNameProductMovement(undefined)
    setSelectedVendor(undefined)
    setSelectedOriginExpiry(undefined)

    let data
    if (reportOrderData) {
      data =
        reportOrderData?.data?.filter((obj) => obj.supplier === option.name) ||
        []

      setFilterReportOrderData(data)
    } else if (reportSupplierProductData) {
      data =
        reportSupplierProductData?.data?.filter(
          (obj) => obj.supplier_details === option.name
        ) || []

      setFilteredReportSupplierProductData(data)
    } else if (supplierWiseSalesData) {
      data =
        supplierWiseSalesData?.data?.filter(
          (obj) => obj.supplier_name === option.name
        ) || []

      setFilteredSupplierWiseSalesData(data)
    } else if (supplierWiseStockPositionData) {
      // Filter out products with 0 balance quantity
      data =
        supplierWiseStockPositionData?.data?.filter(
          (obj) => obj.supplier_name === option.name && obj.balance_qty !== 0
        ) || []

      setFilteredSupplierWiseStockPositionData(data)
    } else if (supplierWiseProductMovementData) {
      data =
        supplierWiseProductMovementData?.data?.filter(
          (obj) => obj.supplier_name === option.name
        ) || []

      setFilteredSupplierWiseProductMovementData(groupWithSummarySupplierWiseProductMovement(data))
      setExpandedProductMovementGroups({})
    } else if (productExpiryData) {
      data =
        productExpiryData?.data?.filter(
          (obj) => obj.supplier_name === option.name
        ) || []

      setFilteredProductExpiryData(data)
    }
  }

  const filterSalesManReportData = (option) => {
    if (!option?.name) {
      setFilteredDailySalesSummaryData(dailySalesSummaryData?.data)
      setSelectedPaymentMode(undefined)
      return
    }

    setSelectedPaymentMode(undefined)

    let data =
      dailySalesSummaryData?.data?.filter(
        (obj) => obj.sales_man === option.name
      ) || []

    setFilteredDailySalesSummaryData(data)
  }

  const filterProductTypeReportData = (option) => {
    setSelectedProductType(option)
    if (!option?.name) {
      setFilteredSupplierWiseSalesData(supplierWiseSalesData?.data)
      // Filter out products with 0 balance quantity for stock position
      setFilteredSupplierWiseStockPositionData(
        supplierWiseStockPositionData?.data?.filter(item => item.balance_qty !== 0) || []
      )
      setFilteredSupplierWiseProductMovementData(
        groupWithSummarySupplierWiseProductMovement(supplierWiseProductMovementData?.data)
      )
      setExpandedProductMovementGroups({})
      setFilteredProductExpiryData(productExpiryData?.data)
      return
    }

    setSelectedGenericName(undefined)
    setSelectedSupplier(undefined)
    setSelectedOrigin(undefined)
    setSelectedGenericNameStock(undefined)
    setSelectedGenericNameProductMovement(undefined)
    setSelectedVendor(undefined)
    setSelectedOriginExpiry(undefined)

    let data
    if (supplierWiseSalesData) {
      data =
        supplierWiseSalesData?.data?.filter(
          (obj) => obj.product_type === option.name
        ) || []
      setFilteredSupplierWiseSalesData(data)
    } else if (supplierWiseStockPositionData) {
      // Filter out products with 0 balance quantity
      data =
        supplierWiseStockPositionData?.data?.filter(
          (obj) => obj.product_type === option.name && obj.balance_qty !== 0
        ) || []
      setFilteredSupplierWiseStockPositionData(data)
    } else if (supplierWiseProductMovementData) {
      data =
        supplierWiseProductMovementData?.data?.filter(
          (obj) => obj.product_type === option.name
        ) || []
      setFilteredSupplierWiseProductMovementData(groupWithSummarySupplierWiseProductMovement(data))
      setExpandedProductMovementGroups({})
    } else if (productExpiryData) {
      data =
        productExpiryData?.data?.filter(
          (obj) => obj.product_type === option.name
        ) || []
      setFilteredProductExpiryData(data)
    }
  }

  const filterGenericNameReportData = (option) => {
    setSelectedGenericName(option)
    if (!option?.name) {
      setFilteredSupplierWiseSalesData(supplierWiseSalesData?.data)
      return
    }

    setSelectedProductType(undefined)
    setSelectedSupplier(undefined)

    let data =
      supplierWiseSalesData?.data?.filter(
        (obj) => obj.generic_name === option.name
      ) || []

    setFilteredSupplierWiseSalesData(data)
  }

  const filterSupplierProductTypeReportData = (option) => {
    setSelectedSupplierProductType(option)
    if (!option?.name) {
      setFilteredReportSupplierProductData(reportSupplierProductData?.data)
      return
    }

    setSelectedSupplier(undefined)

    let data =
      reportSupplierProductData?.data?.filter(
        (obj) => obj.product_type === option.name
      ) || []

    setFilteredReportSupplierProductData(data)
  }

  const getSupplierProductTypeOptions = () => {
    let data = reportSupplierProductData?.data || []
    const productTypeOptionsArray = []
    let productTypeSet = new Set()

    data.map((obj) => {
      productTypeSet.add(obj.product_type)
    })

    productTypeSet.forEach((option) =>
      productTypeOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return productTypeOptionsArray
  }

  const getInvoiceDetails = (id) => {
    if (!id) return

    getInvoiceDetailsHelper(id)
      .then((res) => {
        setInvoiceData(res)
        setViewInventoryActive(true)
      })
      .catch((err) => {
        console.log('Error fetching invoice details:', err)
      })
  }

  const getSupplierOptions = () => {
    const data =
      reportSupplierProductData?.data ||
      reportOrderData?.data ||
      supplierWiseSalesData?.data ||
      supplierWiseStockPositionData?.data ||
      supplierWiseProductMovementData?.data ||
      productExpiryData?.data ||
      []

    const supplierMap = new Map()

    data.forEach((obj) => {
      const supplierName =
        obj.supplier_details || obj.supplier || obj.supplier_name
      const supplierId =
        obj.supplier_id || obj.pharmacy_supplier_id || supplierName

      if (supplierName && !supplierMap.has(supplierId)) {
        supplierMap.set(supplierId, {
          supplier_id: supplierId,
          name: supplierName,
          label: supplierName,
        })
      }
    })

    return Array.from(supplierMap.values())
  }

  const handleDownloadClick = async (type) => {
    if (!startDate || !endDate || !reportType || !subType) return
    if (downloadingType) return

    setDownloadingType(type)

    let data = {
      startDate,
      endDate,
      reportType: reportType?.name,
      subType: subType?.name,
    }

    // Add branch filter if user has manage permission and selected a branch
    if (hasManagePermission && selectedBranch) {
      if (selectedBranch.id === 'ALL') {
        data.allBranches = true
        data.branchName = 'All Branches'
      } else {
        data.branchId = selectedBranch.id
        data.branchName = selectedBranch.name
      }
    }

    if (reportType?.name === 'PURCHASE') {
      if (selectedSupplier?.supplier_id) {
        data.pharmacySupplierId = selectedSupplier.supplier_id
      }
      if (selectedSupplierProductType?.name) {
        data.productType = selectedSupplierProductType.name
      }
    }

    if (reportType?.name === 'SALES') {
      if (subType?.name === 'DAILY_SALES_SUMMARY' && selectedSupplier?.name) {
        // For Daily Sales Summary, the selected filter is actually sales-man
        data.salesMan = selectedSupplier.name
      } else if (subType?.name === 'SUPPLIER_WISE') {
        if (selectedSupplier?.supplier_id) {
          data.pharmacySupplierId = selectedSupplier.supplier_id
        }
        if (selectedProductType?.name) {
          data.productType = selectedProductType.name
        }
        if (selectedGenericName?.name) {
          data.genericName = selectedGenericName.name
        }
      }
    }

    if (reportType?.name === 'INVENTORY') {
      // SUBTYPE: SUPPLIER_WISE_STOCK_POSITION
      if (subType?.name === 'SUPPLIER_WISE_STOCK_POSITION') {
        data.includeExpired = true
        if (selectedSupplier?.supplier_id) {
          data.pharmacySupplierId = selectedSupplier.supplier_id
        }
        if (selectedProductType?.name) {
          data.productType = selectedProductType.name
        }
      }

      // SUBTYPE: SUPPLIER_WISE_PRODUCT_MOVEMENT
      else if (subType?.name === 'SUPPLIER_WISE_PRODUCT_MOVEMENT') {
        if (selectedSupplier?.supplier_id) {
          data.pharmacySupplierId = selectedSupplier.supplier_id
        }
        if (selectedProductType?.name) {
          data.productType = selectedProductType.name
        }
        if (selectedGenericName?.name) {
          data.genericName = selectedGenericName.name
        }
      }
    }
    // if (reportType?.name === 'INVENTORY') {
    //   if (selectedSupplier?.supplier_id) {
    //     data.pharmacySupplierId = selectedSupplier.supplier_id
    //   }
    //   if (selectedProductType?.name) {
    //     data.productType = selectedProductType.name
    //   }
    // }
    try {
      console.log('Download data with filters:', data)
      if (type === 'PDF') {
        await downloadReportPdfHelper(data)
      } else if (type === 'CSV') {
        await downloadReportExcelHelper(data)
      }
    } catch (err) {
      console.log('Download error: ', err)
    } finally {
      setToggle(false)
      setDownloadingType(null)
    }
  }
  const getProductTypeOptions = () => {
    let data =
      supplierWiseSalesData?.data ||
      supplierWiseStockPositionData?.data ||
      supplierWiseProductMovementData?.data ||
      productExpiryData?.data ||
      []
    const productTypeOptionsArray = []
    let productTypeSet = new Set()

    data.map((obj) => {
      productTypeSet.add(obj.product_type)
    })

    productTypeSet.forEach((option) =>
      productTypeOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return productTypeOptionsArray
  }

  const getGenericNameOptions = () => {
    let data = supplierWiseSalesData?.data || []
    const genericNameOptionsArray = []
    let genericNameSet = new Set()

    data.map((obj) => {
      genericNameSet.add(obj.generic_name)
    })

    genericNameSet.forEach((option) =>
      genericNameOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return genericNameOptionsArray
  }

  // Helper function to group and add summary rows for supplier wise product movement data
  // Groups by product_details only (not by supplier)
  const groupWithSummarySupplierWiseProductMovement = (data) => {
    if (!data || data.length === 0) return []
    
    const groupedMap = new Map()
    
    data.forEach((item) => {
      // Use product_details as the grouping key
      const key = item.product_details || `${item.product_name || ''}_${item.size || ''}_${item.strength || ''}`
      
      if (!groupedMap.has(key)) {
        groupedMap.set(key, [])
      }
      groupedMap.get(key).push(item)
    })
    
    const result = []
    
    groupedMap.forEach((items, key) => {
      if (items.length > 1) {
        const summaryRow = {
          groupKey: key,
          supplier_name: '-',
          vendor_name: '-',
          product_name: items[0].product_name,
          product_details: items[0].product_details,
          size: items[0].size,
          strength: items[0].strength,
          generic_name: items[0].generic_name,
          category: items[0].category,
          product_type: items[0].product_type,
          origin: items[0].origin,
          total_received_qty: items.reduce((sum, item) => sum + (item.total_received_qty || 0), 0),
          total_sold_qty: items.reduce((sum, item) => sum + (item.total_sold_qty || 0), 0),
          expired_returned_qty: items.reduce((sum, item) => sum + (item.expired_returned_qty || 0), 0),
          exchange_return_qty: items.reduce((sum, item) => sum + (item.exchange_return_qty || 0), 0),
          balance_qty: items.reduce((sum, item) => sum + (item.balance_qty || 0), 0),
          total_cost: items.reduce((sum, item) => sum + (item.total_cost || 0), 0),
          total_sell_value: items.reduce((sum, item) => sum + (item.total_sell_value || 0), 0),
          cpu: '-',
          last_purchase_date: '-',
          last_sell_date: '-',
          isSummaryRow: true
        }
        result.push(summaryRow)
        
        items.forEach(item => {
          result.push({ ...item, groupKey: key, isSummaryRow: false, isDetailRow: true })
        })
      } else {
        result.push({ ...items[0], groupKey: key, isSummaryRow: false, isDetailRow: false })
      }
    })
    
    return result
  }

  const toggleProductMovementGroup = (groupKey) => {
    setExpandedProductMovementGroups(prev => ({
      ...prev,
      [groupKey]: !prev[groupKey]
    }))
  }

  const getGenericNameStockOptions = () => {
    let data = supplierWiseStockPositionData?.data || []
    const genericNameOptionsArray = []
    let genericNameSet = new Set()

    data.forEach((obj) => {
      if (obj.generic_name) {
        genericNameSet.add(obj.generic_name)
      }
    })

    genericNameSet.forEach((option) =>
      genericNameOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return genericNameOptionsArray
  }

  const getGenericNameProductMovementOptions = () => {
    let data = supplierWiseProductMovementData?.data || []
    const genericNameOptionsArray = []
    let genericNameSet = new Set()

    data.forEach((obj) => {
      if (obj.generic_name) {
        genericNameSet.add(obj.generic_name)
      }
    })

    genericNameSet.forEach((option) =>
      genericNameOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return genericNameOptionsArray
  }

  const getOriginOptions = () => {
    let data = supplierWiseStockPositionData?.data || []
    const originOptionsArray = []
    let originSet = new Set()

    data.forEach((obj) => {
      if (obj.origin) {
        originSet.add(obj.origin)
      }
    })

    originSet.forEach((option) =>
      originOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return originOptionsArray
  }

  const getVendorOptions = () => {
    let data = productExpiryData?.data || []
    const vendorOptionsArray = []
    let vendorSet = new Set()

    data.forEach((obj) => {
      if (obj.vendor_name) {
        vendorSet.add(obj.vendor_name)
      }
    })

    vendorSet.forEach((option) =>
      vendorOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return vendorOptionsArray
  }

  const getOriginExpiryOptions = () => {
    let data = productExpiryData?.data || []
    const originOptionsArray = []
    let originSet = new Set()

    data.forEach((obj) => {
      if (obj.origin) {
        originSet.add(obj.origin)
      }
    })

    originSet.forEach((option) =>
      originOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return originOptionsArray
  }

  const filterGenericNameStockReportData = (option) => {
    setSelectedGenericNameStock(option)
    if (!option?.name) {
      setFilteredSupplierWiseStockPositionData(
        supplierWiseStockPositionData?.data?.filter(item => item.balance_qty !== 0) || []
      )
      return
    }

    setSelectedProductType(undefined)
    setSelectedSupplier(undefined)
    setSelectedOrigin(undefined)

    let data =
      supplierWiseStockPositionData?.data?.filter(
        (obj) => obj.generic_name === option.name && obj.balance_qty !== 0
      ) || []

    setFilteredSupplierWiseStockPositionData(data)
  }

  const filterOriginReportData = (option) => {
    setSelectedOrigin(option)
    if (!option?.name) {
      setFilteredSupplierWiseStockPositionData(
        supplierWiseStockPositionData?.data?.filter(item => item.balance_qty !== 0) || []
      )
      return
    }

    setSelectedProductType(undefined)
    setSelectedSupplier(undefined)
    setSelectedGenericNameStock(undefined)

    let data =
      supplierWiseStockPositionData?.data?.filter(
        (obj) => obj.origin === option.name && obj.balance_qty !== 0
      ) || []

    setFilteredSupplierWiseStockPositionData(data)
  }

  const filterGenericNameProductMovementReportData = (option) => {
    setSelectedGenericNameProductMovement(option)
    if (!option?.name) {
      setFilteredSupplierWiseProductMovementData(
        groupWithSummarySupplierWiseProductMovement(supplierWiseProductMovementData?.data)
      )
      setExpandedProductMovementGroups({})
      return
    }

    setSelectedProductType(undefined)
    setSelectedSupplier(undefined)

    let data =
      supplierWiseProductMovementData?.data?.filter(
        (obj) => obj.generic_name === option.name
      ) || []

    setFilteredSupplierWiseProductMovementData(groupWithSummarySupplierWiseProductMovement(data))
    setExpandedProductMovementGroups({})
  }

  const filterVendorReportData = (option) => {
    setSelectedVendor(option)
    if (!option?.name) {
      setFilteredProductExpiryData(productExpiryData?.data)
      return
    }

    setSelectedSupplier(undefined)
    setSelectedProductType(undefined)
    setSelectedOriginExpiry(undefined)

    let data =
      productExpiryData?.data?.filter(
        (obj) => obj.vendor_name === option.name
      ) || []

    setFilteredProductExpiryData(data)
  }

  const filterOriginExpiryReportData = (option) => {
    setSelectedOriginExpiry(option)
    if (!option?.name) {
      setFilteredProductExpiryData(productExpiryData?.data)
      return
    }

    setSelectedSupplier(undefined)
    setSelectedProductType(undefined)
    setSelectedVendor(undefined)

    let data =
      productExpiryData?.data?.filter(
        (obj) => obj.origin === option.name
      ) || []

    setFilteredProductExpiryData(data)
  }

  const getSalesManOptions = () => {
    let data = dailySalesSummaryData?.data
    const salesManOptionsArray = []
    let salesManSet = new Set()

    data.map((obj) => {
      salesManSet.add(obj.sales_man)
    })

    salesManSet.forEach((option) =>
      salesManOptionsArray.push({
        name: option,
        label: option,
      })
    )

    return salesManOptionsArray
  }

  const getPaymentModeOptions = () => {
    // Use dailySalesSummaryData for Daily Sales Summary, or reportInvoicePurchaseData for Invoice Purchase
    let data = dailySalesSummaryData?.data || reportInvoicePurchaseData?.data || []
    const paymentModeOptionsArray = []
    let paymentModeSet = new Set()

    data.forEach((obj) => {
      if (obj.payment_mode) {
        // Split payment modes if they contain multiple (e.g., "Cash, Card")
        const modes = obj.payment_mode.split(',').map(m => m.trim())
        modes.forEach(mode => {
          if (mode) paymentModeSet.add(mode)
        })
      }
    })

    paymentModeSet.forEach((option) =>
      paymentModeOptionsArray.push({
        name: option,
        label: convertToTitleCase(option),
      })
    )

    return paymentModeOptionsArray
  }

  const filterPaymentModeReportData = (option) => {
    setSelectedPaymentMode(option)
    if (!option?.name) {
      // Handle both Daily Sales Summary and Invoice Purchase reports
      if (dailySalesSummaryData) {
        setFilteredDailySalesSummaryData(dailySalesSummaryData?.data)
      } else {
        setFilterReportInvoicePurchaseData(reportInvoicePurchaseData?.data)
      }
      return
    }

    // Handle Daily Sales Summary
    if (dailySalesSummaryData) {
      let data =
        dailySalesSummaryData?.data?.filter(
          (obj) => obj.payment_mode?.toUpperCase() === option.name.toUpperCase()
        ) || []
      setFilteredDailySalesSummaryData(data)
    } else {
      // Handle Invoice Purchase
      let data =
        reportInvoicePurchaseData?.data?.filter(
          (obj) => obj.payment_mode === option.name
        ) || []
      setFilterReportInvoicePurchaseData(data)
    }
  }

  const getSubTypeOptions = () => {
    if (!reportType) {
      return []
    }

    let options
    switch (reportType?.name) {
      case 'PURCHASE':
        options = [
          {
            name: 'SUPPLIER_AND_PRODUCT',
            label: 'Supplier and Product',
          },
          {
            name: 'ORDER_SUBMIT',
            label: 'Order Submit',
          },
          {
            name: 'INVOICE_WISE_PURCHASE_REPORT',
            label: 'Invoice Wise Purchase Report',
          },
        ]
        break
      case 'SALES':
        options = [
          {
            name: 'DAILY_SALES_SUMMARY',
            label: 'Daily Sales Summary',
          },
          {
            name: 'SUPPLIER_WISE',
            label: 'Supplier wise',
          },
        ]
        break
      case 'INVENTORY':
        options = [
          {
            name: 'SUPPLIER_WISE_STOCK_POSITION',
            label: 'Supplier wise Stock Position',
          },
          {
            name: 'SUPPLIER_WISE_PRODUCT_MOVEMENT',
            label: 'Supplier wise Product Movement',
          },
          {
            name: 'PRODUCT_EXPIRY',
            label: 'Product Expiry',
          },
        ]
        break
      default:
        options = []
        break
    }

    return options
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      <div className="pageBodyRightPanel reportsWrapper">
        <div className="addProductBtnMobile dFlex aiCenter fixed">
          <div className="buttonOptionsWrapper">
            <button
              className="animated zoomIn btn btnPrimary ml-2"
              onClick={() => setToggle(!toggle)}
            >
              <DownloadIcon />
            </button>

            {toggle && (
              <ul className="buttonOptions">
                <li
                  className="option"
                  onClick={() => handleDownloadClick('PDF')}
                  style={{
                    pointerEvents: downloadingType ? 'none' : 'auto',
                    opacity: downloadingType ? 0.5 : 1,
                  }}
                >
                  {downloadingType === 'PDF' ? 'PDF Processing...' : 'PDF'}
                </li>
                <li
                  className="option"
                  onClick={() => handleDownloadClick('CSV')}
                  style={{
                    pointerEvents: downloadingType ? 'none' : 'auto',
                    opacity: downloadingType ? 0.5 : 1,
                  }}
                >
                  {downloadingType === 'CSV' ? 'CSV Processing...' : 'CSV'}
                </li>
              </ul>
            )}
          </div>
        </div>

        <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-4">
          <div className="pageBodyRightPanelHeading">Reports</div>
          <div className="addProductBtn dFlex aiCenter">
            <div className="pointer ml-4">
              <CloseIcon />
            </div>
          </div>
        </div>
        <form>
          <div className="dFlex">
            <div className="formGroup formFloating mb-0 flex1">
              <input
                type="date"
                className="formControl"
                id="email"
                menuPosition="fixed"
                placeholder="From"
                onChange={(event) => setStartDate(event.target.value)}
                required
              />
              <label for="address">From</label>
            </div>
            <div className="formGroup formFloating mb-0 ml-4 flex1">
              <input
                type="date"
                className="formControl"
                id="email"
                menuPosition="fixed"
                placeholder="To"
                onChange={(event) => setEndDate(event.target.value)}
                required
              />
              <label for="address">To</label>
            </div>
            <div
              className={`formGroup formFloating mb-0 flex1 ${
                !isMobile ? 'ml-4' : 'mt-5 flexBreak50'
              }`}
            >
              <Select
                className="formSelect reactSelect"
                id="floatingSelect"
                getOptionLabel={(option) => option.label}
                menuPosition="fixed"
                placeholder="Select Report Type"
                styles={{
                  control: (base) => ({
                    border: 0,
                    display: 'flex',
                    paddingTop: '20px',
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused
                      ? 'rgb(222, 235, 255)'
                      : state.isSelected
                        ? '#FFF'
                        : 'inherit',
                    color: '#212529',
                    '&:hover': {
                      backgroundColor: state.isSelected
                        ? '#DEEBFF'
                        : 'rgb(222, 235, 255)',
                    },
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 100000,
                  }),
                }}
                value={reportType}
                options={[
                  {
                    name: 'PURCHASE',
                    label: 'Purchase',
                  },
                  {
                    name: 'SALES',
                    label: 'Sales',
                  },
                  {
                    name: 'INVENTORY',
                    label: 'Inventory',
                  },
                ]}
                onChange={(option) => {
                  setSubType('')
                  setReportType(option)
                }}
                isClearable
              />

              {/* <select className="formSelect" id="floatingSelect">
                                <option value="1">Purchase</option>
                                <option value="2">Sale</option>
                            </select> */}
              <label for="floatingSelect">Report Type</label>
              {false && (
                <div className="invalidFeedback">
                  Please choose Report Type.
                </div>
              )}
            </div>
            <div
              className={`formGroup formFloating mb-0 flex1 ml-4 ${
                !isMobile ? '' : 'mt-5 flexBreak50'
              }`}
            >
              <Select
                className="formSelect reactSelect"
                id="floatingSelect"
                getOptionLabel={(option) => option.label}
                menuPosition="fixed"
                placeholder="Select Sub Type"
                styles={{
                  control: (base) => ({
                    border: 0,
                    display: 'flex',
                    paddingTop: '20px',
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused
                      ? 'rgb(222, 235, 255)'
                      : state.isSelected
                        ? '#FFF'
                        : 'inherit',
                    color: '#212529',
                    '&:hover': {
                      backgroundColor: state.isSelected
                        ? '#DEEBFF'
                        : 'rgb(222, 235, 255)',
                    },
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 100000,
                  }),
                }}
                value={subType}
                options={getSubTypeOptions()}
                onChange={(option) => setSubType(option)}
                isClearable
              />

              {/* <select className="formSelect" id="floatingSelect">
                                <option value="1">Order Wise</option>
                                <option value="2">Supplier Wise</option>
                                <option value="2">Product Wise</option>
                            </select> */}
              <label for="floatingSelect">Sub Type</label>
              {false && (
                <div className="invalidFeedback">Please choose Sub Type.</div>
              )}
            </div>
            {hasManagePermission && (
              <div
                className={`formGroup formFloating mb-0 flex1 ml-4 ${
                  !isMobile ? '' : 'mt-5 flexBreak50'
                }`}
              >
                <Select
                  className="formSelect reactSelect"
                  id="floatingSelectBranch"
                  getOptionLabel={(option) => option.label}
                  menuPosition="fixed"
                  placeholder="Select Branch"
                  styles={{
                    control: (base) => ({
                      border: 0,
                      display: 'flex',
                      paddingTop: '20px',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused
                        ? 'rgb(222, 235, 255)'
                        : state.isSelected
                          ? '#FFF'
                          : 'inherit',
                      color: '#212529',
                      '&:hover': {
                        backgroundColor: state.isSelected
                          ? '#DEEBFF'
                          : 'rgb(222, 235, 255)',
                      },
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 100000,
                    }),
                  }}
                  value={selectedBranch}
                  options={branchList}
                  onChange={(option) => setSelectedBranch(option)}
                  isClearable
                />
                <label htmlFor="floatingSelectBranch">Branch</label>
              </div>
            )}
            <div
              className={`actionButton dFlex ${
                !isMobile ? 'ml-4' : 'mt-5 flexBreak'
              }`}
            >
              <button
                className="btn btnPrimary dFlex aiCenter block jcContentCenter"
                onClick={(event) => {
                  event?.preventDefault()
                  handleSubmit()
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
        <div className="reportsWrapperBody">
          {isSubmitLoading && <Loading />}
          {!isSubmitLoading && filteredReportSupplierProductData && (
            <div className="mt-5 tableResponsive">
              {isAllBranchesSelected ? (
                <>
                  {Object.entries(groupDataByBranch(filteredReportSupplierProductData)).map(
                    ([branchName, branchData]) => {
                      const totals = calculateSupplierProductBranchTotals(branchData)
                      const isExpanded = expandedBranch === branchName
                      return (
                        <div key={branchName} className="branchGroupTable mb-4">
                          <table className="table reports">
                            <thead className="tableHeader branchHeader">
                              <tr>
                                <td colSpan="12" style={{ backgroundColor: '#e8f5e9', fontWeight: 'bold' }}>
                                  {branchName}
                                </td>
                              </tr>
                              <tr>
                                <td className="stickyHeader">Supplier</td>
                                <td className="stickyHeader">Product Details</td>
                                <td className="stickyHeader">Product Type</td>
                                <td className="stickyHeader">Batch No.</td>
                                <td className="stickyHeader">Expiry Date</td>
                                <td className="stickyHeader">Category</td>
                                <td className="stickyHeader">Rcv Qty</td>
                                <td className="stickyHeader">Bonus Qty</td>
                                <td className="stickyHeader">Total Qty</td>
                                <td className="stickyHeader">CPU (BDT)</td>
                                <td className="stickyHeader">Total Cost (BDT)</td>
                                <td className="stickyHeader"></td>
                              </tr>
                            </thead>
                            <tbody>
                              {isExpanded &&
                                branchData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.supplier_details}</td>
                                    <td>{item.product_details}</td>
                                    <td>{item.product_type}</td>
                                    <td>{item.batch_number}</td>
                                    <td>{item.expiry_date}</td>
                                    <td>{item.category}</td>
                                    <td>{item.rec_qty}</td>
                                    <td>{item.bonus_qty}</td>
                                    <td>{item.total_qty}</td>
                                    <td>{currencyFormatter(item.cpu)}</td>
                                    <td>{currencyFormatter(item.total_cost)}</td>
                                    <td></td>
                                  </tr>
                                ))}
                            </tbody>
                            <tfoot>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <td colSpan="6"><strong>Total</strong></td>
                                <td>{totals.rec_qty}</td>
                                <td>{totals.bonus_qty}</td>
                                <td>{totals.total_qty}</td>
                                <td></td>
                                <td>{parseFloat(totals.total_cost).toFixed(2)}</td>
                                <td>
                                  <button
                                    className="btn btnLink"
                                    style={{ color: '#4caf50', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    onClick={() => handleViewAllClick(branchName)}
                                  >
                                    {isExpanded ? 'Hide' : 'View all'}
                                  </button>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )
                    }
                  )}
                  <table className="table reports">
                    <tfoot>
                      <tr style={{ backgroundColor: '#c8e6c9', fontWeight: 'bold' }}>
                        <td colSpan="6"><strong>All Branch Total</strong></td>
                        <td>{filteredReportSupplierProductData.reduce((t, i) => t + (i.rec_qty || 0), 0)}</td>
                        <td>{filteredReportSupplierProductData.reduce((t, i) => t + (i.bonus_qty || 0), 0)}</td>
                        <td>{filteredReportSupplierProductData.reduce((t, i) => t + (i.total_qty || 0), 0)}</td>
                        <td></td>
                        <td>{parseFloat(filteredReportSupplierProductData.reduce((t, i) => t + (i.total_cost || 0), 0)).toFixed(2)}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </>
              ) : (
                <table className="table reports">
                  <thead className="tableHeader">
                    <tr>
                      <td className="stickyHeader">Invoice No & Date</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select Supplier"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            input: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: '#fff',
                              '&:hover': {
                                color: '#fff',
                              },
                            }),
                            clearIndicator: (base) => ({
                              ...base,
                              color: '#fff',
                              '&:hover': {
                                color: '#fff',
                              },
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedSupplier || ''}
                          options={getSupplierOptions()}
                          onChange={(option) => filterSupplierReportData(option)}
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Vendor Name</td>
                      <td className="stickyHeader">Product Details</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Product Type"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            input: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: '#fff',
                              '&:hover': {
                                color: '#fff',
                              },
                            }),
                            clearIndicator: (base) => ({
                              ...base,
                              color: '#fff',
                              '&:hover': {
                                color: '#fff',
                              },
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedSupplierProductType || ''}
                          options={getSupplierProductTypeOptions()}
                          onChange={(option) => filterSupplierProductTypeReportData(option)}
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Product Origin</td>
                      <td className="stickyHeader">Batch No.</td>
                      <td className="stickyHeader" style={{ whiteSpace: 'nowrap' }}>Expiry Date</td>
                      <td className="stickyHeader">Category</td>
                      <td className="stickyHeader">Rcv Qty</td>
                      <td className="stickyHeader">Bonus Qty</td>
                      <td className="stickyHeader">Total Qty</td>
                      <td className="stickyHeader">CPU (BDT)</td>
                      <td className="stickyHeader">Total Cost (BDT)</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredReportSupplierProductData?.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.pharmacy_invoice_id ? (
                            <span
                              className="invoiceLink"
                              style={{ color: '#EF8658', cursor: 'pointer', textDecoration: 'underline' }}
                              onClick={(e) => {
                                e.stopPropagation()
                                getInvoiceDetails(item.pharmacy_invoice_id)
                              }}
                            >
                              {item.invoice_number}
                            </span>
                          ) : (
                            item.invoice_number
                          )}
                          {item.invoice_date && <div style={{ fontSize: '12px', color: '#666' }}>{item.invoice_date}</div>}
                        </td>
                        <td>{item.supplier_details}</td>
                        <td>{item.vendor_name || '-'}</td>
                        <td>{item.product_name}{item.size ? ` (${item.size})` : ''}{item.strength ? `-${item.strength}` : ''}</td>
                        <td>{item.product_type}</td>
                        <td>{item.origin || '-'}</td>
                        <td>{item.batch_number}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{item.expiry_date}</td>
                        <td>{item.category}</td>
                        <td>{item.rec_qty}</td>
                        <td>{item.bonus_qty}</td>
                        <td>{item.total_qty}</td>
                        <td>{currencyFormatter(item.cpu)}</td>
                        <td>{currencyFormatter(item.total_cost)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="9">Total</td>
                      <td>
                        {filteredReportSupplierProductData.reduce(
                          (total, item) => {
                            return total + (item.rec_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredReportSupplierProductData.reduce(
                          (total, item) => {
                            return total + (item.bonus_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredReportSupplierProductData.reduce(
                          (total, item) => {
                            return total + (item.total_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {parseFloat(
                          filteredReportSupplierProductData.reduce(
                            (total, item) => {
                              return total + (item.cpu || 0)
                            },
                            0
                          )
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredReportSupplierProductData.reduce(
                            (total, item) => {
                              return total + (item.total_cost || 0)
                            },
                            0
                          )
                        ).toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}
          {!isSubmitLoading && filterReportOrderData && (
            <div className="mt-5 tableResponsive">
              {isAllBranchesSelected ? (
                <>
                  {Object.entries(groupDataByBranch(filterReportOrderData)).map(
                    ([branchName, branchData]) => {
                      const totals = calculateOrderSubmitBranchTotals(branchData)
                      const isExpanded = expandedBranch === branchName
                      return (
                        <div key={branchName} className="branchGroupTable mb-4">
                          <table className="table reports">
                            <thead className="tableHeader branchHeader">
                              <tr>
                                <td colSpan="7" style={{ backgroundColor: '#e8f5e9', fontWeight: 'bold' }}>
                                  {branchName}
                                </td>
                              </tr>
                              <tr>
                                <td className="stickyHeader">Supplier</td>
                                <td className="stickyHeader">Product Details</td>
                                <td className="stickyHeader">Category</td>
                                <td className="stickyHeader">Order Qty</td>
                                <td className="stickyHeader">CPU (BDT)</td>
                                <td className="stickyHeader">Total Cost (BDT)</td>
                                <td className="stickyHeader"></td>
                              </tr>
                            </thead>
                            <tbody>
                              {isExpanded &&
                                branchData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.supplier}</td>
                                    <td>{item.product_details}</td>
                                    <td>{item.category}</td>
                                    <td>{item.order_qty}</td>
                                    <td>{currencyFormatter(item.cpu)}</td>
                                    <td>{currencyFormatter(item.total_cost)}</td>
                                    <td></td>
                                  </tr>
                                ))}
                            </tbody>
                            <tfoot>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <td colSpan="3"><strong>Total</strong></td>
                                <td>{totals.order_qty}</td>
                                <td></td>
                                <td>{parseFloat(totals.total_cost).toFixed(2)}</td>
                                <td>
                                  <button
                                    className="btn btnLink"
                                    style={{ color: '#4caf50', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    onClick={() => handleViewAllClick(branchName)}
                                  >
                                    {isExpanded ? 'Hide' : 'View all'}
                                  </button>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )
                    }
                  )}
                  <table className="table reports">
                    <tfoot>
                      <tr style={{ backgroundColor: '#c8e6c9', fontWeight: 'bold' }}>
                        <td colSpan="3"><strong>All Branch Total</strong></td>
                        <td>{filterReportOrderData.reduce((t, i) => t + (i.order_qty || 0), 0)}</td>
                        <td></td>
                        <td>{parseFloat(filterReportOrderData.reduce((t, i) => t + (i.total_cost || 0), 0)).toFixed(2)}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </>
              ) : (
                <table className="table reports">
                  <thead className="tableHeader">
                    <tr>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select Supplier"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedSupplier || ''}
                          options={getSupplierOptions()}
                          onChange={(option) => filterSupplierReportData(option)}
                          isClearable
                        />
                      </td>
                      <td>Product Details</td>
                      <td>Category</td>
                      <td>Order Qty</td>
                      <td>CPU (BDT)</td>
                      <td>Total Cost (BDT)</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filterReportOrderData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.supplier}</td>
                        <td>{item.product_details}</td>
                        <td>{item.category}</td>
                        <td>{item.order_qty}</td>
                        <td>{currencyFormatter(item.cpu)}</td>
                        <td>{currencyFormatter(item.total_cost)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3">Total</td>
                      <td>
                        {filterReportOrderData.reduce((total, item) => {
                          return total + (item.order_qty || 0)
                        }, 0)}
                      </td>
                      <td></td>
                      <td>
                        {parseFloat(
                          filterReportOrderData.reduce((total, item) => {
                            return total + (item.total_cost || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}

          {!isSubmitLoading && filterReportInvoicePurchaseData && (
            <div className="mt-5 tableResponsive">
              {isAllBranchesSelected ? (
                <>
                  {Object.entries(groupDataByBranch(filterReportInvoicePurchaseData)).map(
                    ([branchName, branchData]) => {
                      const totals = calculateInvoicePurchaseBranchTotals(branchData)
                      const isExpanded = expandedBranch === branchName
                      return (
                        <div key={branchName} className="branchGroupTable mb-4">
                          <table className="table reports">
                            <thead className="tableHeader branchHeader">
                              <tr>
                                <td colSpan="13" style={{ backgroundColor: '#e8f5e9', fontWeight: 'bold' }}>
                                  {branchName}
                                </td>
                              </tr>
                              <tr>
                                <td className="stickyHeader">Date</td>
                                <td className="stickyHeader">Invoice No.</td>
                                <td className="stickyHeader">Order Book Invoice No.</td>
                                <td className="stickyHeader">Supplier's Name</td>
                                <td className="stickyHeader">Vendor's Name</td>
                                <td className="stickyHeader">Amount (BDT)</td>
                                <td className="stickyHeader">VAT Amount (+)</td>
                                <td className="stickyHeader">Trade Discount (-)</td>
                                <td className="stickyHeader">Total (BDT)</td>
                                <td className="stickyHeader">Payment Mode</td>
                                <td className="stickyHeader">Note</td>
                                <td className="stickyHeader">Received By</td>
                                <td className="stickyHeader"></td>
                              </tr>
                            </thead>
                            <tbody>
                              {isExpanded &&
                                branchData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.created_at}</td>
                                    <td>{item.invoice_number}</td>
                                    <td>{item.order_book_invoice_number}</td>
                                    <td>{item.supplier_name}</td>
                                    <td>{item.vendor_name}</td>
                                    <td>{currencyFormatter(item.amount)}</td>
                                    <td>{item.vat}</td>
                                    <td>{item.trade_discount}</td>
                                    <td>{currencyFormatter(item.total_amount)}</td>
                                    <td>{convertToTitleCase(item.payment_mode)}</td>
                                    <td>{item.notes}</td>
                                    <td>{item.received_by}</td>
                                    <td></td>
                                  </tr>
                                ))}
                            </tbody>
                            <tfoot>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <td colSpan="5"><strong>Total</strong></td>
                                <td>{parseFloat(totals.amount).toFixed(2)}</td>
                                <td>{parseFloat(totals.vat).toFixed(2)}</td>
                                <td>{parseFloat(totals.trade_discount).toFixed(2)}</td>
                                <td>{parseFloat(totals.total_amount).toFixed(2)}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <button
                                    className="btn btnLink"
                                    style={{ color: '#4caf50', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    onClick={() => handleViewAllClick(branchName)}
                                  >
                                    {isExpanded ? 'Hide' : 'View all'}
                                  </button>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )
                    }
                  )}
                  <table className="table reports">
                    <tfoot>
                      <tr style={{ backgroundColor: '#c8e6c9', fontWeight: 'bold' }}>
                        <td colSpan="5"><strong>All Branch Total</strong></td>
                        <td>{parseFloat(filterReportInvoicePurchaseData.reduce((t, i) => t + (i.amount || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filterReportInvoicePurchaseData.reduce((t, i) => t + (i.vat || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filterReportInvoicePurchaseData.reduce((t, i) => t + (i.trade_discount || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filterReportInvoicePurchaseData.reduce((t, i) => t + (i.total_amount || 0), 0)).toFixed(2)}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </>
              ) : (
                <table className="table reports">
                  <thead className="tableHeader">
                    <tr>
                      <td>Date</td>
                      <td>Invoice No.</td>
                      <td>Order Book Invoice No.</td>
                      <td>Supplier's Name</td>
                      <td>Vendor's Name</td>
                      <td>Amount (BDT)</td>
                      <td>VAT Amount (+)</td>
                      <td>Trade Discount (-)</td>
                      <td>Total (BDT)</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Payment Mode"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#FFF',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#FFF',
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: '#FFF',
                            }),
                            clearIndicator: (base) => ({
                              ...base,
                              color: '#FFF',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedPaymentMode || ''}
                          options={getPaymentModeOptions()}
                          onChange={(option) => filterPaymentModeReportData(option)}
                          isClearable
                        />
                      </td>
                      <td>Note</td>
                      <td>Received By</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filterReportInvoicePurchaseData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.created_at}</td>
                        <td>{item.invoice_number}</td>
                        <td>{item.order_book_invoice_number}</td>
                        <td>{item.supplier_name}</td>
                        <td>{item.vendor_name}</td>
                        <td>{currencyFormatter(item.amount)}</td>
                        <td>{item.vat}</td>
                        <td>{item.trade_discount}</td>
                        <td>{currencyFormatter(item.total_amount)}</td>
                        <td>{convertToTitleCase(item.payment_mode)}</td>
                        <td>{item.notes}</td>
                        <td>{item.received_by}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="5">Total</td>
                      <td>
                        {reportInvoicePurchaseData?.total?.overall_amount}
                      </td>
                      <td>{reportInvoicePurchaseData?.total?.overall_vat}</td>
                      <td>
                        {reportInvoicePurchaseData?.total?.overall_trade_discount}
                      </td>
                      <td>
                        {reportInvoicePurchaseData?.total?.overall_total_amount}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}

          {!isSubmitLoading && filteredDailySalesSummaryData && (
            <div className="mt-5 tableResponsive">
              {/* Grouped by Branch View when All Branches selected */}
              {isAllBranchesSelected ? (
                <>
                  {Object.entries(groupDataByBranch(filteredDailySalesSummaryData)).map(
                    ([branchName, branchData]) => {
                      const totals = calculateDailySalesBranchTotals(branchData)
                      const isExpanded = expandedBranch === branchName
                      return (
                        <div key={branchName} className="branchGroupTable mb-4">
                          <table className="table reports">
                            <thead className="tableHeader branchHeader">
                              <tr>
                                <td colSpan="17" style={{ backgroundColor: '#e8f5e9', fontWeight: 'bold' }}>
                                  {branchName}
                                </td>
                              </tr>
                              <tr>
                                <td className="stickyHeader">Invoice No.</td>
                                <td className="stickyHeader">Date & Time</td>
                                <td className="stickyHeader">MRP</td>
                                <td className="stickyHeader">Discount (BDT) (-)</td>
                                <td className="stickyHeader">VAT (+)</td>
                                <td className="stickyHeader">Ex/Ret Amt (-)</td>
                                <td className="stickyHeader">Net Amount</td>
                                <td className="stickyHeader">Sales Type</td>
                                <td className="stickyHeader">Cash Sale</td>
                                <td className="stickyHeader">Card Sale</td>
                                <td className="stickyHeader">Online Sale</td>
                                <td className="stickyHeader">Due Sale</td>
                                <td className="stickyHeader">Notes</td>
                                <td className="stickyHeader">Total CPU</td>
                                <td className="stickyHeader">Profit Amt.</td>
                                <td className="stickyHeader">Gross Profit %</td>
                                <td className="stickyHeader">Sales-man</td>
                              </tr>
                            </thead>
                            <tbody>
                              {isExpanded &&
                                branchData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.invoice_number}</td>
                                    <td>{item.date_and_time}</td>
                                    <td>{item.mrp}</td>
                                    <td>{item.discount}</td>
                                    <td>{item.vat}</td>
                                    <td>{item.ex_ret_amount}</td>
                                    <td>{currencyFormatter(item.net_amount)}</td>
                                    <td>{item.sales_type}</td>
                                    <td>{item.cash_sale}</td>
                                    <td>{item.card_sale}</td>
                                    <td>{item.online_sale}</td>
                                    <td>{item.due_sales}</td>
                                    <td>{item.notes}</td>
                                    <td>{item.total_cpu}</td>
                                    <td>{currencyFormatter(item.profit_amount)}</td>
                                    <td>{item.gp}</td>
                                    <td>{item.sales_man}</td>
                                  </tr>
                                ))}
                            </tbody>
                            <tfoot>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <td colSpan="2"><strong>Total</strong></td>
                                <td>{parseFloat(totals.mrp).toFixed(2)}</td>
                                <td>{parseFloat(totals.discount).toFixed(2)}</td>
                                <td>{parseFloat(totals.vat).toFixed(2)}</td>
                                <td>{parseFloat(totals.ex_ret_amount).toFixed(2)}</td>
                                <td>{parseFloat(totals.net_amount).toFixed(2)}</td>
                                <td></td>
                                <td>{parseFloat(totals.cash_sale).toFixed(2)}</td>
                                <td>{parseFloat(totals.card_sale).toFixed(2)}</td>
                                <td>{parseFloat(totals.online_sale).toFixed(2)}</td>
                                <td>{parseFloat(totals.due_sales).toFixed(2)}</td>
                                <td></td>
                                <td>{parseFloat(totals.total_cpu).toFixed(2)}</td>
                                <td>{parseFloat(totals.profit_amount).toFixed(2)}</td>
                                <td>
                                  {totals.total_cpu
                                    ? parseFloat((totals.profit_amount / totals.total_cpu) * 100).toFixed(2)
                                    : 0}
                                </td>
                                <td>
                                  <button
                                    className="btn btnLink"
                                    style={{ color: '#4caf50', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    onClick={() => handleViewAllClick(branchName)}
                                  >
                                    {isExpanded ? 'Hide' : 'View all'}
                                  </button>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )
                    }
                  )}
                  {/* All Branches Total */}
                  <table className="table reports">
                    <tfoot>
                      <tr style={{ backgroundColor: '#c8e6c9', fontWeight: 'bold' }}>
                        <td colSpan="2"><strong>All Branch Total</strong></td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.mrp || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.discount || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.vat || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.ex_ret_amount || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.net_amount || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td></td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.cash_sale || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.card_sale || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.online_sale || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.due_sales || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td></td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.total_cpu || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {parseFloat(
                            filteredDailySalesSummaryData?.reduce((total, item) => total + (item.profit_amount || 0), 0)
                          ).toFixed(2)}
                        </td>
                        <td>
                          {(() => {
                            const totalProfit = filteredDailySalesSummaryData?.reduce(
                              (total, item) => total + (item.profit_amount || 0),
                              0
                            )
                            const totalCPU = filteredDailySalesSummaryData?.reduce(
                              (total, item) => total + (item.total_cpu || 0),
                              0
                            )
                            return totalCPU ? parseFloat((totalProfit / totalCPU) * 100).toFixed(2) : 0
                          })()}
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </>
              ) : (
                /* Regular View when specific branch selected */
                <table className="table reports">
                  <thead className="tableHeader">
                    <tr>
                      <td className="stickyHeader">Invoice No.</td>
                      <td className="stickyHeader">Date & Time</td>
                      <td className="stickyHeader">Customer Name & Contact</td>
                      <td className="stickyHeader">MRP</td>
                      <td className="stickyHeader">Discount (BDT) (-)</td>
                      <td className="stickyHeader">VAT</td>
                      <td className="stickyHeader">Ex/Ret Amt (-)</td>
                      <td className="stickyHeader">Net Amount</td>
                      <td className="stickyHeader">Sales Type</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Payment Mode"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedPaymentMode || ''}
                          options={getPaymentModeOptions()}
                          onChange={(option) => filterPaymentModeReportData(option)}
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Transaction Charge (BDT)</td>
                      <td className="stickyHeader">Total CPU</td>
                      <td className="stickyHeader">Profit Amt.</td>
                      <td className="stickyHeader">Gross Profit %</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Sales-man"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedSupplier || ''}
                          options={getSalesManOptions()}
                          onChange={(option) => filterSalesManReportData(option)}
                          isClearable
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredDailySalesSummaryData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.invoice_number}</td>
                        <td>{item.date_and_time}</td>
                        <td>{item.customer_name ? `${item.customer_name}${item.customer_contact ? ` (${item.customer_contact})` : ''}` : '-'}</td>
                        <td>{item.mrp}</td>
                        <td>{item.discount}</td>
                        <td>{item.vat}</td>
                        <td>{item.ex_ret_amount}</td>
                        <td>{currencyFormatter(item.net_amount)}</td>
                        <td>{item.sales_type}</td>
                        <td>{item.payment_mode ? (PAYMENT_MODE_OPTIONS.find(opt => opt.name === item.payment_mode)?.label || convertToTitleCase(item.payment_mode)) : '-'}</td>
                        <td>{item.transaction_charge || 0}</td>
                        <td>{item.total_cpu}</td>
                        <td>{currencyFormatter((item.profit_amount || 0) - (item.transaction_charge || 0))}</td>
                        <td>{item.gp}</td>
                        <td>{item.sales_man}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3">Total</td>
                      <td>
                        {parseFloat(
                          filteredDailySalesSummaryData?.reduce((total, item) => {
                            return total + (item.mrp || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredDailySalesSummaryData?.reduce((total, item) => {
                            return total + (item.discount || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredDailySalesSummaryData?.reduce((total, item) => {
                            return total + (item.vat || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredDailySalesSummaryData?.reduce((total, item) => {
                            return total + (item.ex_ret_amount || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredDailySalesSummaryData?.reduce((total, item) => {
                            return total + (item.net_amount || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td></td>
                      <td></td>
                      <td>
                        {parseFloat(
                          filteredDailySalesSummaryData?.reduce((total, item) => {
                            return total + (item.transaction_charge || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredDailySalesSummaryData?.reduce((total, item) => {
                            return total + (item.total_cpu || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredDailySalesSummaryData?.reduce((total, item) => {
                            return total + ((item.profit_amount || 0) - (item.transaction_charge || 0))
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {(() => {
                          const totalProfit =
                            filteredDailySalesSummaryData?.reduce(
                              (total, item) => total + ((item.profit_amount || 0) - (item.transaction_charge || 0)),
                              0
                            )

                          const totalCPU = filteredDailySalesSummaryData?.reduce(
                            (total, item) => total + (item.total_cpu || 0),
                            0
                          )

                          const percentage = totalCPU
                            ? (totalProfit / totalCPU) * 100
                            : 0

                          return parseFloat(percentage.toFixed(2))
                        })()}
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}
          {!isSubmitLoading && filteredSupplierWiseSalesData && (
            <div className="mt-5 tableResponsive">
              {isAllBranchesSelected ? (
                <>
                  {Object.entries(groupDataByBranch(filteredSupplierWiseSalesData)).map(
                    ([branchName, branchData]) => {
                      const totals = calculateSupplierWiseSalesBranchTotals(branchData)
                      const isExpanded = expandedBranch === branchName
                      return (
                        <div key={branchName} className="branchGroupTable mb-4">
                          <table className="table reports">
                            <thead className="tableHeader branchHeader">
                              <tr>
                                <td colSpan="15" style={{ backgroundColor: '#e8f5e9', fontWeight: 'bold' }}>
                                  {branchName}
                                </td>
                              </tr>
                              <tr>
                                <td className="stickyHeader">Supplier</td>
                                <td className="stickyHeader">Product Details</td>
                                <td className="stickyHeader">Sold Qty</td>
                                <td className="stickyHeader">CPU</td>
                                <td className="stickyHeader">MRP</td>
                                <td className="stickyHeader">Discount</td>
                                <td className="stickyHeader">VAT (+)</td>
                                <td className="stickyHeader">Sub Total</td>
                                <td className="stickyHeader">Ex/Ret</td>
                                <td className="stickyHeader">Net Amount</td>
                                <td className="stickyHeader">Total Profit</td>
                                <td className="stickyHeader">Gross Profit %</td>
                                <td className="stickyHeader">Product Type</td>
                                <td className="stickyHeader">Generic Name</td>
                                <td className="stickyHeader"></td>
                              </tr>
                            </thead>
                            <tbody>
                              {isExpanded &&
                                branchData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.supplier_name}</td>
                                    <td>{item.product_details}</td>
                                    <td>{item.sold_qty}</td>
                                    <td>{item.cpu}</td>
                                    <td>{item.mrp}</td>
                                    <td>{item.discount}</td>
                                    <td>{item.vat}</td>
                                    <td>{item.sub_total}</td>
                                    <td>{item.ex_ret}</td>
                                    <td>{item.net_amount}</td>
                                    <td>{item.total_profit}</td>
                                    <td>{item.gp}</td>
                                    <td>{item.product_type}</td>
                                    <td>{item.generic_name}</td>
                                    <td></td>
                                  </tr>
                                ))}
                            </tbody>
                            <tfoot>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <td colSpan="2"><strong>Total</strong></td>
                                <td>{parseFloat(totals.sold_qty).toFixed(2)}</td>
                                <td>{parseFloat(totals.cpu).toFixed(2)}</td>
                                <td>{parseFloat(totals.mrp).toFixed(2)}</td>
                                <td>{parseFloat(totals.discount).toFixed(2)}</td>
                                <td>{parseFloat(totals.vat).toFixed(2)}</td>
                                <td>{parseFloat(totals.sub_total).toFixed(2)}</td>
                                <td>{parseFloat(totals.ex_ret).toFixed(2)}</td>
                                <td>{parseFloat(totals.net_amount).toFixed(2)}</td>
                                <td>{parseFloat(totals.total_profit).toFixed(2)}</td>
                                <td>{totals.cpu ? parseFloat((totals.total_profit / totals.cpu) * 100).toFixed(2) : 0}</td>
                                <td></td>
                                <td></td>
                                <td>
                                  <button
                                    className="btn btnLink"
                                    style={{ color: '#4caf50', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    onClick={() => handleViewAllClick(branchName)}
                                  >
                                    {isExpanded ? 'Hide' : 'View all'}
                                  </button>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )
                    }
                  )}
                  <table className="table reports">
                    <tfoot>
                      <tr style={{ backgroundColor: '#c8e6c9', fontWeight: 'bold' }}>
                        <td colSpan="2"><strong>All Branch Total</strong></td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.sold_qty || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.cpu || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.mrp || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.discount || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.vat || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.sub_total || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.ex_ret || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.net_amount || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseSalesData.reduce((t, i) => t + (i.total_profit || 0), 0)).toFixed(2)}</td>
                        <td>
                          {(() => {
                            const totalProfit = filteredSupplierWiseSalesData.reduce((t, i) => t + (i.total_profit || 0), 0)
                            const totalCPU = filteredSupplierWiseSalesData.reduce((t, i) => t + (i.cpu || 0), 0)
                            return totalCPU ? parseFloat((totalProfit / totalCPU) * 100).toFixed(2) : 0
                          })()}
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </>
              ) : (
                <table className="table reports">
                  <thead className="tableHeader">
                    <tr>
                      <td className="stickyHeader" style={{ color: '#fff' }}>Invoice No & Date</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select Supplier"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedSupplier || ''}
                          options={getSupplierOptions()}
                          onChange={(option) => filterSupplierReportData(option)}
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Vendor Name</td>
                      <td className="stickyHeader">Product Details</td>
                      <td className="stickyHeader">Category</td>
                      <td className="stickyHeader">Sold Qty</td>
                      <td className="stickyHeader">CPU</td>
                      <td className="stickyHeader">MRP</td>
                      <td className="stickyHeader">Discount</td>
                      <td className="stickyHeader">VAT (+)</td>
                      <td className="stickyHeader">Sub Total</td>
                      <td className="stickyHeader">Ex/Ret Qty</td>
                      <td className="stickyHeader">Net Amount</td>
                      <td className="stickyHeader">Total Profit</td>
                      <td className="stickyHeader">Gross Profit %</td>
                      <td className="stickyHeader">Origin</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Product Type"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedProductType || ''}
                          options={getProductTypeOptions()}
                          onChange={(option) =>
                            filterProductTypeReportData(option)
                          }
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Generic Name"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedGenericName || ''}
                          options={getGenericNameOptions()}
                          onChange={(option) =>
                            filterGenericNameReportData(option)
                          }
                          isClearable
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSupplierWiseSalesData?.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <span
                            className="invoiceLink"
                            style={{ color: '#E87A41', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => handleViewInvoice(item.sales_order_id)}
                          >
                            {item.invoice_number}
                          </span>
                          <br />
                          <small>{item.invoice_date}</small>
                        </td>
                        <td>{item.supplier_name}</td>
                        <td>{item.vendor_name || '-'}</td>
                        <td>{item.product_name}{item.size ? ` (${item.size})` : ''}{item.strength ? `-${item.strength}` : ''}</td>
                        <td>{item.category || '-'}</td>
                        <td>{item.sold_qty}</td>
                        <td>{item.cpu}</td>
                        <td>{item.mrp}</td>
                        <td>{item.discount}</td>
                        <td>{item.vat}</td>
                        <td>{item.sub_total}</td>
                        <td>{item.ex_ret_qty || 0}</td>
                        <td>{item.net_amount}</td>
                        <td>{item.total_profit}</td>
                        <td>
                          {(() => {
                            const totalCost = (item.cpu || 0) * (item.sold_qty || 0)
                            const gp = totalCost > 0 ? ((item.total_profit || 0) / totalCost) * 100 : 0
                            return parseFloat(gp.toFixed(2))
                          })()}
                        </td>
                        <td>{item.origin || '-'}</td>
                        <td>{item.product_type}</td>
                        <td>{item.generic_name}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="5">Total</td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + (item.sold_qty || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + ((item.cpu || 0) * (item.sold_qty || 0))
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + (item.mrp || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + (item.discount || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + (item.vat || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + (item.sub_total || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + (item.ex_ret_qty || 0)
                          }, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + (item.net_amount || 0)
                          }, 0)
                        ).toFixed(2) || 0}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseSalesData?.reduce((total, item) => {
                            return total + (item.total_profit || 0)
                          }, 0)
                        ).toFixed(2) || 0}
                      </td>
                      <td>
                        {(() => {
                          const totalProfit =
                            filteredSupplierWiseSalesData?.reduce(
                              (total, item) => total + (item.total_profit || 0),
                              0
                            )

                          const totalCost = filteredSupplierWiseSalesData?.reduce(
                            (total, item) => total + ((item.cpu || 0) * (item.sold_qty || 0)),
                            0
                          )

                          const percentage = totalCost
                            ? (totalProfit / totalCost) * 100
                            : 0

                          return parseFloat(percentage.toFixed(2))
                        })()}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}
          {!isSubmitLoading && filteredSupplierWiseStockPositionData && (
            <div className="mt-5 tableResponsive">
              {isAllBranchesSelected ? (
                <>
                  {Object.entries(groupDataByBranch(filteredSupplierWiseStockPositionData)).map(
                    ([branchName, branchData]) => {
                      const totals = calculateStockPositionBranchTotals(branchData)
                      const isExpanded = expandedBranch === branchName
                      return (
                        <div key={branchName} className="branchGroupTable mb-4">
                          <table className="table reports">
                            <thead className="tableHeader branchHeader">
                              <tr>
                                <td colSpan="19" style={{ backgroundColor: '#e8f5e9', fontWeight: 'bold' }}>
                                  {branchName}
                                </td>
                              </tr>
                              <tr>
                                <td className="stickyHeader">Supplier</td>
                                <td className="stickyHeader">Vendor Name</td>
                                <td className="stickyHeader">Product Details</td>
                                <td className="stickyHeader">Generic Name</td>
                                <td className="stickyHeader">Category</td>
                                <td className="stickyHeader">Batch number</td>
                                <td className="stickyHeader">Expiry date</td>
                                <td className="stickyHeader">Total Purchased Qty</td>
                                <td className="stickyHeader">Total Sold Qty</td>
                                <td className="stickyHeader">Damage/Loss</td>
                                <td className="stickyHeader">Exch/ Return</td>
                                <td className="stickyHeader">Balance Qty</td>
                                <td className="stickyHeader">CPU</td>
                                <td className="stickyHeader">Total Cost</td>
                                <td className="stickyHeader">RPU</td>
                                <td className="stickyHeader">Total Sell Value</td>
                                <td className="stickyHeader">Product Type</td>
                                <td className="stickyHeader">Origin</td>
                                <td className="stickyHeader"></td>
                              </tr>
                            </thead>
                            <tbody>
                              {isExpanded &&
                                branchData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.supplier_name}</td>
                                    <td>{item.vendor_name || '-'}</td>
                                    <td>{item.product_name}{item.size ? ` (${item.size})` : ''}{item.strength ? `-${item.strength}` : ''}</td>
                                    <td>{item.generic_name || '-'}</td>
                                    <td>{item.category}</td>
                                    <td>{item.batch_number}</td>
                                    <td>{item.expiry_date}</td>
                                    <td>{item.total_purchased_qty}</td>
                                    <td>{item.total_sold_qty}</td>
                                    <td>{item.damage_loss_qty}</td>
                                    <td>{item.exch_return_qty}</td>
                                    <td>{item.balance_qty}</td>
                                    <td>{item.cpu}</td>
                                    <td>{item.total_cost}</td>
                                    <td>{item.rpu}</td>
                                    <td>{item.total_sell_value}</td>
                                    <td>{item.product_type}</td>
                                    <td>{item.origin}</td>
                                    <td></td>
                                  </tr>
                                ))}
                            </tbody>
                            <tfoot>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <td colSpan="7"><strong>Total</strong></td>
                                <td>{totals.total_purchased_qty}</td>
                                <td>{totals.total_sold_qty}</td>
                                <td>{totals.damage_loss_qty}</td>
                                <td>{totals.exch_return_qty}</td>
                                <td>{totals.balance_qty}</td>
                                <td></td>
                                <td>{parseFloat(totals.total_cost).toFixed(2)}</td>
                                <td></td>
                                <td>{parseFloat(totals.total_sell_value).toFixed(2)}</td>
                                <td></td>
                                <td></td>
                                <td>
                                  <button
                                    className="btn btnLink"
                                    style={{ color: '#4caf50', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    onClick={() => handleViewAllClick(branchName)}
                                  >
                                    {isExpanded ? 'Hide' : 'View all'}
                                  </button>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )
                    }
                  )}
                  <table className="table reports">
                    <tfoot>
                      <tr style={{ backgroundColor: '#c8e6c9', fontWeight: 'bold' }}>
                        <td colSpan="7"><strong>All Branch Total</strong></td>
                        <td>{filteredSupplierWiseStockPositionData.reduce((t, i) => t + (i.total_purchased_qty || 0), 0)}</td>
                        <td>{filteredSupplierWiseStockPositionData.reduce((t, i) => t + (i.total_sold_qty || 0), 0)}</td>
                        <td>{filteredSupplierWiseStockPositionData.reduce((t, i) => t + (i.damage_loss_qty || 0), 0)}</td>
                        <td>{filteredSupplierWiseStockPositionData.reduce((t, i) => t + (i.exch_return_qty || 0), 0)}</td>
                        <td>{filteredSupplierWiseStockPositionData.reduce((t, i) => t + (i.balance_qty || 0), 0)}</td>
                        <td></td>
                        <td>{parseFloat(filteredSupplierWiseStockPositionData.reduce((t, i) => t + (i.total_cost || 0), 0)).toFixed(2)}</td>
                        <td></td>
                        <td>{parseFloat(filteredSupplierWiseStockPositionData.reduce((t, i) => t + (i.total_sell_value || 0), 0)).toFixed(2)}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </>
              ) : (
                <table className="table reports">
                  <thead className="tableHeader">
                    <tr>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select Supplier"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            input: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedSupplier || ''}
                          options={getSupplierOptions()}
                          onChange={(option) => filterSupplierReportData(option)}
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Vendor Name</td>
                      <td className="stickyHeader">Product Details</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Generic Name"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            input: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedGenericNameStock || ''}
                          options={getGenericNameStockOptions()}
                          onChange={(option) => filterGenericNameStockReportData(option)}
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Category</td>
                      <td className="stickyHeader">Batch number</td>
                      <td className="stickyHeader">Expiry date</td>
                      <td className="stickyHeader">Total Purchased Qty</td>
                      <td className="stickyHeader">Total Sold Qty</td>
                      <td className="stickyHeader">Damage/Loss</td>
                      <td className="stickyHeader">Exch/ Return</td>
                      <td className="stickyHeader">Balance Qty</td>
                      <td className="stickyHeader">CPU</td>
                      <td className="stickyHeader">Total Cost</td>
                      <td className="stickyHeader">RPU</td>
                      <td className="stickyHeader">Total Sell Value</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Product Type"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            input: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedProductType || ''}
                          options={getProductTypeOptions()}
                          onChange={(option) =>
                            filterProductTypeReportData(option)
                          }
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Origin"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            input: (provided) => ({
                              ...provided,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedOrigin || ''}
                          options={getOriginOptions()}
                          onChange={(option) => filterOriginReportData(option)}
                          isClearable
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSupplierWiseStockPositionData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.supplier_name}</td>
                        <td>{item.vendor_name || '-'}</td>
                        <td>{item.product_name}{item.size ? ` (${item.size})` : ''}{item.strength ? `-${item.strength}` : ''}</td>
                        <td>{item.generic_name || '-'}</td>
                        <td>{item.category}</td>
                        <td>{item.batch_number}</td>
                        <td>{item.expiry_date}</td>
                        <td>{item.total_purchased_qty}</td>
                        <td>{item.total_sold_qty}</td>
                        <td>{item.damage_loss_qty}</td>
                        <td>{item.exch_return_qty}</td>
                        <td>{item.balance_qty}</td>
                        <td>{item.cpu}</td>
                        <td>{item.total_cost}</td>
                        <td>{item.rpu}</td>
                        <td>{item.total_sell_value}</td>
                        <td>{item.product_type}</td>
                        <td>{item.origin}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="7">Total</td>
                      <td>
                        {filteredSupplierWiseStockPositionData?.reduce(
                          (total, item) => {
                            return total + (item.total_purchased_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredSupplierWiseStockPositionData?.reduce(
                          (total, item) => {
                            return total + (item.total_sold_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredSupplierWiseStockPositionData?.reduce(
                          (total, item) => {
                            return total + (item.damage_loss_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredSupplierWiseStockPositionData?.reduce(
                          (total, item) => {
                            return total + (item.exch_return_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredSupplierWiseStockPositionData?.reduce(
                          (total, item) => {
                            return total + (item.balance_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td></td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseStockPositionData?.reduce(
                            (total, item) => {
                              return total + (item.total_cost || 0)
                            },
                            0
                          )
                        ).toFixed(2)}
                      </td>
                      <td></td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseStockPositionData?.reduce(
                            (total, item) => {
                              return total + (item.total_sell_value || 0)
                            },
                            0
                          )
                        ).toFixed(2)}
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}
          {!isSubmitLoading && filteredSupplierWiseProductMovementData && (
            <div className="mt-5 tableResponsive">
              {isAllBranchesSelected ? (
                <>
                  {Object.entries(groupDataByBranch(filteredSupplierWiseProductMovementData)).map(
                    ([branchName, branchData]) => {
                      const totals = calculateProductMovementBranchTotals(branchData)
                      const isExpanded = expandedBranch === branchName
                      return (
                        <div key={branchName} className="branchGroupTable mb-4">
                          <table className="table reports">
                            <thead className="tableHeader branchHeader">
                              <tr>
                                <td colSpan="11" style={{ backgroundColor: '#e8f5e9', fontWeight: 'bold' }}>
                                  {branchName}
                                </td>
                              </tr>
                              <tr>
                                <td className="stickyHeader">Supplier</td>
                                <td className="stickyHeader">Product Details</td>
                                <td className="stickyHeader">Category</td>
                                <td className="stickyHeader">Total Received Qty</td>
                                <td className="stickyHeader">Total Sold Qty</td>
                                <td className="stickyHeader">Balance Qty</td>
                                <td className="stickyHeader">Total Cost</td>
                                <td className="stickyHeader">Total Sell Value</td>
                                <td className="stickyHeader">Product Type</td>
                                <td className="stickyHeader">Origin</td>
                                <td className="stickyHeader"></td>
                              </tr>
                            </thead>
                            <tbody>
                              {isExpanded &&
                                branchData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.supplier_name}</td>
                                    <td>{item.product_name}{item.size ? ` (${item.size})` : ''}{item.strength ? `-${item.strength}` : ''}</td>
                                    <td>{item.category}</td>
                                    <td>{item.total_received_qty}</td>
                                    <td>{item.total_sold_qty}</td>
                                    <td>{item.balance_qty}</td>
                                    <td>{item.total_cost}</td>
                                    <td>{item.total_sell_value}</td>
                                    <td>{item.product_type}</td>
                                    <td>{item.origin}</td>
                                    <td></td>
                                  </tr>
                                ))}
                            </tbody>
                            <tfoot>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <td colSpan="3"><strong>Total</strong></td>
                                <td>{totals.total_received_qty}</td>
                                <td>{totals.total_sold_qty}</td>
                                <td>{totals.balance_qty}</td>
                                <td>{parseFloat(totals.total_cost).toFixed(2)}</td>
                                <td>{parseFloat(totals.total_sell_value).toFixed(2)}</td>
                                <td></td>
                                <td></td>
                                <td>
                                  <button
                                    className="btn btnLink"
                                    style={{ color: '#4caf50', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    onClick={() => handleViewAllClick(branchName)}
                                  >
                                    {isExpanded ? 'Hide' : 'View all'}
                                  </button>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )
                    }
                  )}
                  <table className="table reports">
                    <tfoot>
                      <tr style={{ backgroundColor: '#c8e6c9', fontWeight: 'bold' }}>
                        <td colSpan="3"><strong>All Branch Total</strong></td>
                        <td>{filteredSupplierWiseProductMovementData.reduce((t, i) => t + (i.total_received_qty || 0), 0)}</td>
                        <td>{filteredSupplierWiseProductMovementData.reduce((t, i) => t + (i.total_sold_qty || 0), 0)}</td>
                        <td>{filteredSupplierWiseProductMovementData.reduce((t, i) => t + (i.balance_qty || 0), 0)}</td>
                        <td>{parseFloat(filteredSupplierWiseProductMovementData.reduce((t, i) => t + (i.total_cost || 0), 0)).toFixed(2)}</td>
                        <td>{parseFloat(filteredSupplierWiseProductMovementData.reduce((t, i) => t + (i.total_sell_value || 0), 0)).toFixed(2)}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </>
              ) : (
                <table className="table reports">
                  <thead className="tableHeader">
                    <tr>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select Supplier"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedSupplier || ''}
                          options={getSupplierOptions()}
                          onChange={(option) => filterSupplierReportData(option)}
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Vendor Name</td>
                      <td className="stickyHeader">Product Details</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Generic Name"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedGenericNameProductMovement || ''}
                          options={getGenericNameProductMovementOptions()}
                          onChange={(option) =>
                            filterGenericNameProductMovementReportData(option)
                          }
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Category</td>
                      <td className="stickyHeader">Total Received Qty</td>
                      <td className="stickyHeader">Total Sold Qty</td>
                      <td className="stickyHeader">Expired Returned Qty</td>
                      <td className="stickyHeader">Exchange/Return Qty</td>
                      <td className="stickyHeader">Balance Qty</td>
                      <td className="stickyHeader">CPU</td>
                      <td className="stickyHeader">Total Cost</td>
                      <td className="stickyHeader">Total Sell Value</td>
                      <td className="stickyHeader">Last Purchase Date</td>
                      <td className="stickyHeader">Last Sell Date</td>
                      <td className="stickyHeader selectColumn">
                        <Select
                          className="formSelect reactSelect"
                          id="floatingSelect"
                          getOptionLabel={(option) => option?.label}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Product Type"
                          styles={{
                            control: (base) => ({
                              border: 0,
                              display: 'flex',
                              paddingTop: '20px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#fff',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                  ? '#FFF'
                                  : 'inherit',
                              color: '#212529',
                              '&:hover': {
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : 'rgb(222, 235, 255)',
                              },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          value={selectedProductType || ''}
                          options={getProductTypeOptions()}
                          onChange={(option) =>
                            filterProductTypeReportData(option)
                          }
                          isClearable
                        />
                      </td>
                      <td className="stickyHeader">Origin</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSupplierWiseProductMovementData?.map(
                      (item, index) => {
                        // Hide detail rows if group is not expanded
                        if (item.isDetailRow && !expandedProductMovementGroups[item.groupKey]) {
                          return null
                        }
                        
                        return (
                          <tr 
                            key={index}
                            style={item.isSummaryRow ? { 
                              backgroundColor: '#fff3cd', 
                              fontWeight: 'bold',
                              cursor: 'pointer'
                            } : item.isDetailRow ? {
                              backgroundColor: '#f8f9fa'
                            } : {}}
                            onClick={item.isSummaryRow ? () => toggleProductMovementGroup(item.groupKey) : undefined}
                          >
                            <td>{item.isSummaryRow ? '-' : item.supplier_name}</td>
                            <td>{item.isSummaryRow ? '' : (item.vendor_name || '-')}</td>
                            <td>
                              {item.isSummaryRow ? (
                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ 
                                    display: 'inline-block',
                                    width: '20px',
                                    height: '20px',
                                    textAlign: 'center',
                                    lineHeight: '18px',
                                    border: '1px solid #666',
                                    borderRadius: '3px',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                  }}>
                                    {expandedProductMovementGroups[item.groupKey] ? '−' : '+'}
                                  </span>
                                  {item.product_name}{item.size ? ` (${item.size})` : ''}{item.strength ? `-${item.strength}` : ''}
                                </span>
                              ) : (
                                <span style={{ paddingLeft: item.isDetailRow ? '28px' : '0' }}>
                                  {item.product_name}{item.size ? ` (${item.size})` : ''}{item.strength ? `-${item.strength}` : ''}
                                </span>
                              )}
                            </td>
                            <td>{item.isSummaryRow ? (item.generic_name || '-') : (item.generic_name || '-')}</td>
                            <td>{item.category}</td>
                            <td>{item.total_received_qty}</td>
                            <td>{item.total_sold_qty}</td>
                            <td>{item.expired_returned_qty || 0}</td>
                            <td>{item.exchange_return_qty || 0}</td>
                            <td>{item.balance_qty}</td>
                            <td>{item.isSummaryRow ? '' : (item.cpu || 0)}</td>
                            <td>{parseFloat(item.total_cost || 0).toFixed(2)}</td>
                            <td>{parseFloat(item.total_sell_value || 0).toFixed(2)}</td>
                            <td>{item.isSummaryRow ? '' : (item.last_purchase_date || '-')}</td>
                            <td>{item.isSummaryRow ? '' : (item.last_sell_date || '-')}</td>
                            <td>{item.product_type}</td>
                            <td>{item.origin}</td>
                          </tr>
                        )
                      }
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="5">Total</td>
                      <td>
                        {filteredSupplierWiseProductMovementData?.reduce(
                          (total, item) => {
                            if (item.isSummaryRow) return total
                            return total + (item.total_received_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredSupplierWiseProductMovementData?.reduce(
                          (total, item) => {
                            if (item.isSummaryRow) return total
                            return total + (item.total_sold_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredSupplierWiseProductMovementData?.reduce(
                          (total, item) => {
                            if (item.isSummaryRow) return total
                            return total + (item.expired_returned_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredSupplierWiseProductMovementData?.reduce(
                          (total, item) => {
                            if (item.isSummaryRow) return total
                            return total + (item.exchange_return_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td>
                        {filteredSupplierWiseProductMovementData?.reduce(
                          (total, item) => {
                            if (item.isSummaryRow) return total
                            return total + (item.balance_qty || 0)
                          },
                          0
                        )}
                      </td>
                      <td></td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseProductMovementData?.reduce(
                            (total, item) => {
                              if (item.isSummaryRow) return total
                              return total + (item.total_cost || 0)
                            },
                            0
                          )
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          filteredSupplierWiseProductMovementData?.reduce(
                            (total, item) => {
                              if (item.isSummaryRow) return total
                              return total + (item.total_sell_value || 0)
                            },
                            0
                          )
                        ).toFixed(2)}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}
          {!isSubmitLoading && filteredProductExpiryData && (
            <div className="mt-5 tableResponsive">
              <table className="table reports">
                <thead className="tableHeader">
                  <tr>
                    <td className="stickyHeader selectColumn">
                      <Select
                        className="formSelect reactSelect"
                        id="floatingSelect"
                        getOptionLabel={(option) => option?.label}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Select Supplier"
                        styles={{
                          control: (base) => ({
                            border: 0,
                            display: 'flex',
                            paddingTop: '20px',
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused
                              ? 'rgb(222, 235, 255)'
                              : state.isSelected
                                ? '#FFF'
                                : 'inherit',
                            color: '#212529',
                            '&:hover': {
                              backgroundColor: state.isSelected
                                ? '#DEEBFF'
                                : 'rgb(222, 235, 255)',
                            },
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        value={selectedSupplier || ''}
                        options={getSupplierOptions()}
                        onChange={(option) => filterSupplierReportData(option)}
                        isClearable
                      />
                    </td>
                    <td className="stickyHeader selectColumn">
                      <Select
                        className="formSelect reactSelect"
                        id="floatingSelect"
                        getOptionLabel={(option) => option?.label}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Vendor Name"
                        styles={{
                          control: (base) => ({
                            border: 0,
                            display: 'flex',
                            paddingTop: '20px',
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused
                              ? 'rgb(222, 235, 255)'
                              : state.isSelected
                                ? '#FFF'
                                : 'inherit',
                            color: '#212529',
                            '&:hover': {
                              backgroundColor: state.isSelected
                                ? '#DEEBFF'
                                : 'rgb(222, 235, 255)',
                            },
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        value={selectedVendor || ''}
                        options={getVendorOptions()}
                        onChange={(option) => filterVendorReportData(option)}
                        isClearable
                      />
                    </td>
                    <td className="stickyHeader">Product Details</td>
                    <td className="stickyHeader">Category</td>
                    <td className="stickyHeader">Batch Number</td>
                    <td className="stickyHeader">Expiry Date</td>
                    <td className="stickyHeader">Balance Qty</td>
                    <td className="stickyHeader">Expired Qty</td>
                    <td className="stickyHeader">CPU</td>
                    <td className="stickyHeader">Total Cost</td>
                    <td className="stickyHeader">RPU</td>
                    <td className="stickyHeader">Total Sell Value</td>
                    <td className="stickyHeader selectColumn">
                      <Select
                        className="formSelect reactSelect"
                        id="floatingSelect"
                        getOptionLabel={(option) => option?.label}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Product Type"
                        styles={{
                          control: (base) => ({
                            border: 0,
                            display: 'flex',
                            paddingTop: '20px',
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused
                              ? 'rgb(222, 235, 255)'
                              : state.isSelected
                                ? '#FFF'
                                : 'inherit',
                            color: '#212529',
                            '&:hover': {
                              backgroundColor: state.isSelected
                                ? '#DEEBFF'
                                : 'rgb(222, 235, 255)',
                            },
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        value={selectedProductType || ''}
                        options={getProductTypeOptions()}
                        onChange={(option) => filterProductTypeReportData(option)}
                        isClearable
                      />
                    </td>
                    <td className="stickyHeader selectColumn">
                      <Select
                        className="formSelect reactSelect"
                        id="floatingSelect"
                        getOptionLabel={(option) => option?.label}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Origin"
                        styles={{
                          control: (base) => ({
                            border: 0,
                            display: 'flex',
                            paddingTop: '20px',
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: '#fff',
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused
                              ? 'rgb(222, 235, 255)'
                              : state.isSelected
                                ? '#FFF'
                                : 'inherit',
                            color: '#212529',
                            '&:hover': {
                              backgroundColor: state.isSelected
                                ? '#DEEBFF'
                                : 'rgb(222, 235, 255)',
                            },
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        value={selectedOriginExpiry || ''}
                        options={getOriginExpiryOptions()}
                        onChange={(option) => filterOriginExpiryReportData(option)}
                        isClearable
                      />
                    </td>
                    <td className="stickyHeader">Remaining Days</td>
                  </tr>
                </thead>
                <tbody>
                  {filteredProductExpiryData?.map((item, index) => (
                    <tr key={index} style={item.remaining_days < 0 ? { backgroundColor: '#fff3cd' } : {}}>
                      <td>{item.supplier_name}</td>
                      <td>{item.vendor_name || '-'}</td>
                      <td>{item.product_name}{item.size ? ` (${item.size})` : ''}{item.strength ? `-${item.strength}` : ''}</td>
                      <td>{item.category}</td>
                      <td>{item.batch_number}</td>
                      <td>{item.expiry_date}</td>
                      <td>{item.balance_qty}</td>
                      <td>{item.expired_qty}</td>
                      <td>{item.cpu}</td>
                      <td>{item.total_cost}</td>
                      <td>{item.rpu}</td>
                      <td>{item.total_sell_value}</td>
                      <td>{item.product_type}</td>
                      <td>{item.origin}</td>
                      <td style={item.remaining_days < 0 ? { color: '#dc3545', fontWeight: 'bold' } : {}}>
                        {item.remaining_days}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="6">Total</td>
                    <td>
                      {filteredProductExpiryData?.reduce(
                        (total, item) => total + (item.balance_qty || 0), 0
                      )}
                    </td>
                    <td>
                      {filteredProductExpiryData?.reduce(
                        (total, item) => total + (item.expired_qty || 0), 0
                      )}
                    </td>
                    <td></td>
                    <td>
                      {parseFloat(
                        filteredProductExpiryData?.reduce(
                          (total, item) => total + (item.total_cost || 0), 0
                        )
                      ).toFixed(2)}
                    </td>
                    <td></td>
                    <td>
                      {parseFloat(
                        filteredProductExpiryData?.reduce(
                          (total, item) => total + (item.total_sell_value || 0), 0
                        )
                      ).toFixed(2)}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>

      <ViewInventory
        open={isViewInventoryActive}
        handleDrawerToggle={() => setViewInventoryActive(!isViewInventoryActive)}
        invoiceData={invoiceData}
      />

      {/* ViewSales Drawer for Invoice View */}
      {salesData && (
        <ViewSales
          open={isViewSalesActive}
          handleDrawerToggle={() => setViewSalesActive(!isViewSalesActive)}
          data={salesData}
          loginData={props.loginData}
        />
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
